import VueAxios from 'vue-axios';
import Vue from 'vue';
import Vuex from 'vuex';
import Buefy from 'buefy';
import VeeValidate from 'vee-validate';
import axiosWHA from './axios-wha';
import 'buefy/dist/buefy.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

const axios = axiosWHA(store);

VeeValidate.Validator.extend('verify_password', {
  getMessage: () => { return 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)'; },
  validate: (value) => {
    const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.)');
    return strongRegex.test(value);
  },
});

Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(Buefy, { defaultIconPack: 'fa' });
Vue.use(VeeValidate);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => { return h(App); },
}).$mount('#app');
